import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "grey" }
const _hoisted_2 = {
  key: 0,
  class: "step-profile_refine"
}
const _hoisted_3 = { class: "l-row" }
const _hoisted_4 = { class: "l-col_xs-12 l-col_sm-12 l-col_md-6" }
const _hoisted_5 = {
  value: null,
  disabled: "",
  hidden: ""
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "l-col_xs-12 l-col_sm-12 l-col_md-6" }
const _hoisted_8 = {
  value: null,
  disabled: "",
  hidden: ""
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "step-profile_job-title" }
const _hoisted_11 = {
  value: null,
  disabled: "",
  hidden: ""
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "joy-panel__body" }
const _hoisted_14 = {
  value: null,
  disabled: "",
  hidden: ""
}
const _hoisted_15 = ["value"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  value: null,
  disabled: "",
  hidden: ""
}
const _hoisted_18 = ["value"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  value: null,
  disabled: "",
  hidden: ""
}
const _hoisted_21 = ["value"]

import BriefHubStepLayout from '@/brief-hub/common/ui/layout/BriefHubStepLayout.vue';
    import BriefAdvancedFeatureInformationDialog from '@/brief-hub/common/ui/components/BriefAdvancedFeatureInformationDialog.client.vue';
    import TooltipInfo from '@/brief-hub/common/ui/components/TooltipInfo.vue';
    import {MutationsType} from '@/brief-hub/store/modules/brief/mutations';
    import type {BriefFreelancerJobTitle, BriefFreelancerProfile as FreelancerProfile, Payload} from '@/brief-hub/store/modules/brief/types';
    import {CategoryResult} from '@/brief-hub/deposit/freelancer/CategoryResult';
    import {FreelancerProfileService} from '@/brief-hub/deposit/freelancer/FreelancerProfileService';
    import {DI} from '@/brief-hub/config/DependencyInjection';
    import {FamilyResult} from '@/brief-hub/deposit/freelancer/FamilyResult';
    import {CategoryPredictionResource, ExperienceLevel, FreelancerCategoryResource} from '@/common/api/api-raw-types';
    import CategoriesSuggestion from '@/brief-hub/common/ui/components/CategoriesSuggestion.vue';
    import {useRoute} from 'vue-router';
    import store from '@/brief-hub/store';
    import {computed, inject, ref, watch} from 'vue';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {BriefTrackingService} from '@/brief-hub/brief/BriefTrackingService';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';

    interface ExperienceLevelWithLabel {
        label: string;
        value: ExperienceLevel;
    }

    const jobTitleMinLength = 6;
    const jobTitleMaxLength = 100;

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BriefFreelancerProfileV2',
  setup(__props) {

    const {$msg, $requireMsg, $features} = useGlobalProperties();
    const $route = useRoute();
    const briefFreelancerProfile = ref<FreelancerProfile>(store.getters.briefFreelancerProfile);

    const freelancerProfileService = inject<FreelancerProfileService>(DI.freelancerProfileService);
    const briefTrackingService = inject<BriefTrackingService>(DI.briefTrackingService);

    const briefFreelancerJobTitle = ref<BriefFreelancerJobTitle>(store.getters.briefFreelancerJobTitle);

    const families = ref<FamilyResult[]>([]);
    const selectedFamily = ref<string | null>(briefFreelancerProfile.value.selectedFamily);
    const selectedCategory = ref<string | null>(briefFreelancerProfile.value.selectedCategory);
    const selectedExperienceLevel = ref<ExperienceLevel | null>(briefFreelancerProfile.value.selectedExperienceLevel || null);

    const jobTitle = ref<string>(briefFreelancerJobTitle.value.jobTitle || '');
    const suggestedCategories = ref<FreelancerCategoryResource[]>([]);
    const selectedSuggestedCategory = ref<FreelancerCategoryResource>();
    const automaticallyAffectSuggestedCategory = ref<boolean>(briefFreelancerProfile.value.selectedCategory == null);

    const showManualCategorySelectionButton = ref(false);
    const openManualCategorySelectionPanel = ref(false);

    async function init(): Promise<void> {
        if (document.referrer) {
            store.commit(MutationsType.UPDATE_ORIGIN_REFERRER, document.referrer);
        }
        $requireMsg('customer.brief.form.freelancer.profile.level.*');

        families.value = await getAvailableFamilies();
        selectedFamily.value = retrieveFamilyFromSelectedFamily() || retrieveFamilyFromSelectedCategory();

        briefTrackingService?.triggerBriefFunnelStepEnteredAmplitudeEvent('freelancer_profile', 1, $route);
    }

    init();

    const jobTitleError = computed<boolean>(() => (jobTitle.value?.length && jobTitle.value?.length < jobTitleMinLength) || false);

    const potentialCategories = computed<CategoryResult[] | null>(
        () => families.value?.find((family) => family.family === selectedFamily.value)?.categories || null,
    );

    const levels = computed<ExperienceLevelWithLabel[]>(() => {
        const labelFor = (levelValue: ExperienceLevel) => $msg(`customer.brief.form.freelancer.profile.level.${levelValue}`);
        return [ExperienceLevel.EXPERT, ExperienceLevel.INTERMEDIATE, ExperienceLevel.ENTRY].map((experienceLevel) => ({
            label: labelFor(experienceLevel),
            value: experienceLevel,
        }));
    });

    const validate = computed<boolean>(() => {
        if ($features.ff4JBriefFunnelUpdateCategorySuggestion) {
            return !!(
                selectedFamily.value &&
                selectedCategory.value &&
                selectedExperienceLevel.value &&
                jobTitle.value &&
                jobTitle.value.length >= jobTitleMinLength
            );
        }
        return !!(selectedFamily.value && selectedCategory.value && selectedExperienceLevel.value);
    });

    const isJobTitleIsValid = computed<boolean>(() => {
        if (!jobTitle.value) {
            return false;
        }
        return jobTitle.value.length >= jobTitleMinLength;
    });

    async function getAvailableFamilies(): Promise<FamilyResult[] | []> {
        const [data, error] = await freelancerProfileService!.retrieveFamiliesAndCategories();
        if (error || !data) {
            pushVJoySnackbar({
                props: {
                    message: $msg('customer.brief.error.unknown'),
                    level: 'error',
                },
            });
            return [];
        }
        return data.filter(({family}) => family !== 'other');
    }

    function retrieveFamilyFromSelectedFamily(): string | null {
        return families.value?.find((family: FamilyResult) => family.family === briefFreelancerProfile.value.selectedFamily)?.family || null;
    }

    function retrieveFamilyFromSelectedCategory(): string | null {
        if (!families.value || !selectedCategory.value) {
            return null;
        }

        return (
            families.value.find((family: FamilyResult) => family.categories.find((category) => selectedCategory.value === category.category))
                ?.family || null
        );
    }

    function suggestionsUpdatedBasedOnJobTitle(predictions: CategoryPredictionResource[]): void {
        const cleanExistingSuggestedCategories = () => {
            suggestedCategories.value = [];
            selectedSuggestedCategory.value = undefined;
        };
        const disableManualCategorySelection = () => {
            showManualCategorySelectionButton.value = false;
            openManualCategorySelectionPanel.value = false;
        };
        const showOnlyManualCategorySelectionPanel = () => {
            showManualCategorySelectionButton.value = false;
            openManualCategorySelectionPanel.value = true;
        };
        const thereIsNoSuggestedCategoryForTheJobTitle = (categoryResources: FreelancerCategoryResource[]) => categoryResources.length == 0;

        const displaySuggestedCategoriesAndAllowManualSelection = (categoryResources: FreelancerCategoryResource[]) => {
            suggestedCategories.value = categoryResources;
            showManualCategorySelectionButton.value = true;
            openManualCategorySelectionPanel.value = false;
        };

        const selectedCategoryIsTheFirstSuggestedCategory = () => {
            selectedSuggestedCategory.value = suggestedCategories.value[0];
            selectedCategory.value = selectedSuggestedCategory.value.categoryId;
            selectedFamily.value = selectedSuggestedCategory.value.familyId;
        };

        const suggestedCategoryIsTheSelectedCategoryIfPossible = () => {
            selectedSuggestedCategory.value = suggestedCategories.value.find((suggestion) => suggestion.categoryId === selectedCategory.value);
            openManualCategorySelectionPanel.value = selectedSuggestedCategory.value?.categoryId !== selectedCategory.value;
        };

        cleanExistingSuggestedCategories();
        disableManualCategorySelection();

        const categoryResources = predictions.map((prediction) => prediction.category);

        if (thereIsNoSuggestedCategoryForTheJobTitle(categoryResources)) {
            showOnlyManualCategorySelectionPanel();
            return;
        }

        displaySuggestedCategoriesAndAllowManualSelection(categoryResources);

        if (automaticallyAffectSuggestedCategory.value) {
            selectedCategoryIsTheFirstSuggestedCategory();
        } else {
            suggestedCategoryIsTheSelectedCategoryIfPossible();
            automaticallyAffectSuggestedCategory.value = true;
        }
    }

    function updateSelectedCategoryAndFamilyOnSuggestionClicked(category: FreelancerCategoryResource): void {
        selectedFamily.value = category.familyId;
        selectedCategory.value = category.categoryId;
        openManualCategorySelectionPanel.value = false;
    }

    function onFormChange(): void {
        let payload: Payload | null = null;
        if (validate.value) {
            payload = {
                type: 'FreelancerBriefRequest',
                payload: {
                    freelancerCategories: [selectedCategory.value!],
                    experienceLevel: selectedExperienceLevel.value!,
                    fromSignup: $route.query.origin === 'signup',
                    searchId: $route.query.searchId?.toString(),
                    ...(jobTitle.value ? {jobTitle: jobTitle.value} : {}),
                },
            };
        }
        store.commit(MutationsType.UPDATE_PAYLOAD, payload);
        store.commit(MutationsType.UPDATE_BRIEF_FORM_JOB_TITLE, jobTitle.value);
        store.commit(MutationsType.UPDATE_BRIEF_FORM_PROFILE, {
            selectedCategory: selectedCategory.value,
            selectedExperienceLevel: selectedExperienceLevel.value,
        });
    }

    watch([jobTitle, selectedFamily, selectedCategory, selectedExperienceLevel], onFormChange, {immediate: true});

return (_ctx: any,_cache: any) => {
  const _component_VJoyLabel = _resolveComponent("VJoyLabel")!
  const _component_VJoyInput = _resolveComponent("VJoyInput")!
  const _component_VJoyFormError = _resolveComponent("VJoyFormError")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BriefHubStepLayout, null, {
      right: _withCtx(() => [
        _createVNode(TooltipInfo, {
          icon: "megaphone",
          title: _unref($msg)('customer.brief.form.tooltip.title')
        }, {
          content: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.tooltip.v2')), 1)
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.title.v2')), 1)
      ]),
      default: _withCtx(() => [
        (_unref($features).ff4JBriefFunnelUpdateCategorySuggestion)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_VJoyWrapper, {
                direction: "column",
                align: "stretch",
                "row-gap": "4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_VJoyLabel, { for: "JobTitle" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.job.title.title')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_VJoyInput, {
                    id: "JobTitle",
                    ref: "inputJobTitle",
                    name: "job-title",
                    "heap-id": "search_plus-job_title_input",
                    type: "text",
                    required: "",
                    "model-value": jobTitle.value,
                    placeholder: _unref($msg)('customer.brief.form.freelancer.profile.job.title.placeholder.v2'),
                    min: jobTitleMinLength,
                    max: jobTitleMaxLength,
                    autofocus: "",
                    autocomplete: "off",
                    invalid: jobTitleError.value,
                    "data-testid": "job-title",
                    onInput: _cache[0] || (_cache[0] = (event) => (jobTitle.value = event.target.value))
                  }, null, 8, ["model-value", "placeholder", "invalid"]),
                  (jobTitleError.value)
                    ? (_openBlock(), _createBlock(_component_VJoyFormError, {
                        key: 0,
                        "no-html-error-text": "This is an error"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.job.title.length.error')) + " ", 1),
                              _createElementVNode("span", _hoisted_1, _toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.job.title.length.error.more')), 1)
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (isJobTitleIsValid.value)
                ? (_openBlock(), _createBlock(CategoriesSuggestion, {
                    key: 0,
                    "visible-result": 3,
                    value: jobTitle.value,
                    "selected-category": selectedCategory.value,
                    categories: suggestedCategories.value,
                    onLoad: suggestionsUpdatedBasedOnJobTitle,
                    onSelect: updateSelectedCategoryAndFamilyOnSuggestionClicked
                  }, null, 8, ["value", "selected-category", "categories"]))
                : _createCommentVNode("", true),
              (isJobTitleIsValid.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (showManualCategorySelectionButton.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "step-profile_refine__link m-link",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (openManualCategorySelectionPanel.value = !openManualCategorySelectionPanel.value), ["prevent"]))
                        }, [
                          _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.categories.suggestion.choose')) + " ", 1),
                          _createVNode(_component_VJoyIcon, {
                            name: openManualCategorySelectionPanel.value ? 'chevron-top' : 'chevron-down'
                          }, null, 8, ["name"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_Transition, { name: "fade" }, {
                      default: _withCtx(() => [
                        (openManualCategorySelectionPanel.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                              _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                  _createVNode(_component_VJoyLabel, { for: "selectFamily" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.family')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _withDirectives(_createElementVNode("select", {
                                    id: "selectFamily",
                                    ref: "selectCategories",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedFamily).value = $event)),
                                    class: "m-select",
                                    "aria-label": "select-family",
                                    onChange: _cache[3] || (_cache[3] = ($event: any) => (selectedCategory.value = null))
                                  }, [
                                    _createElementVNode("option", _hoisted_5, _toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.select.family.placeholder')), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(families.value, (family, index) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: index,
                                        value: family.family
                                      }, _toDisplayString(family.name), 9, _hoisted_6))
                                    }), 128))
                                  ], 544), [
                                    [_vModelSelect, selectedFamily.value]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_7, [
                                  _createVNode(_component_VJoyLabel, { for: "selectCategory" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.search')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _withDirectives((_openBlock(), _createElementBlock("select", {
                                    id: "selectCategory",
                                    key: selectedFamily.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedCategory).value = $event)),
                                    class: "m-select",
                                    "aria-label": "select-category"
                                  }, [
                                    _createElementVNode("option", _hoisted_8, _toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.select.category.placeholder')), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(potentialCategories.value, (category) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: category.category,
                                        value: category.category
                                      }, _toDisplayString(category.name), 9, _hoisted_9))
                                    }), 128))
                                  ])), [
                                    [_vModelSelect, selectedCategory.value]
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_VJoyLabel, { for: "selectedExperienceLevel" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.level.label')), 1)
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createElementVNode("select", {
                        id: "selectedExperienceLevel",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedExperienceLevel).value = $event)),
                        class: "m-select",
                        "aria-label": "select-experience-level"
                      }, [
                        _createElementVNode("option", _hoisted_11, _toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.select.experience.placeholder')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levels.value, (level) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: level.value,
                            value: level.value
                          }, _toDisplayString(level.label), 9, _hoisted_12))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, selectedExperienceLevel.value]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_VJoyLabel, { for: "selectFamily" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.family')), 1)
                  ]),
                  _: 1
                }),
                _withDirectives(_createElementVNode("select", {
                  id: "selectFamily",
                  ref: "selectCategories",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedFamily).value = $event)),
                  autofocus: "",
                  required: "",
                  class: "m-select",
                  "aria-label": "select-family",
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (selectedCategory.value = null))
                }, [
                  _createElementVNode("option", _hoisted_14, _toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.select.family.placeholder')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(families.value, (family, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: family.family
                    }, _toDisplayString(family.name), 9, _hoisted_15))
                  }), 128))
                ], 544), [
                  [_vModelSelect, selectedFamily.value]
                ])
              ]),
              (selectedFamily.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_VJoyLabel, { for: "selectCategory" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.search')), 1)
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createElementVNode("select", {
                      id: "selectCategory",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedCategory).value = $event)),
                      required: "",
                      class: "m-select",
                      "aria-label": "select-category"
                    }, [
                      _createElementVNode("option", _hoisted_17, _toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.select.category.placeholder')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(potentialCategories.value, (category) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: category.category,
                          value: category.category
                        }, _toDisplayString(category.name), 9, _hoisted_18))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, selectedCategory.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (selectedCategory.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_VJoyLabel, { for: "selectedExperienceLevel" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.level.label')), 1)
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createElementVNode("select", {
                      id: "selectedExperienceLevel",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedExperienceLevel).value = $event)),
                      required: "",
                      class: "m-select",
                      "aria-label": "select-experience-level"
                    }, [
                      _createElementVNode("option", _hoisted_20, _toDisplayString(_unref($msg)('customer.brief.form.freelancer.profile.select.experience.placeholder')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levels.value, (level) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: level.value,
                          value: level.value
                        }, _toDisplayString(level.label), 9, _hoisted_21))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, selectedExperienceLevel.value]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64)),
        (!_unref($features).projectProposalBriefNoMoreServiceLevelNeeded)
          ? (_openBlock(), _createBlock(BriefAdvancedFeatureInformationDialog, {
              key: 2,
              type: "regular"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})